import { useState } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "@mui/icons-material/Download";
import { getBackgroundJobFileDownload } from "@/api/background-job/getBackgroundJobFileDownload";
import { toErrorText } from "@/components/snapshot/snapshot.utils";

interface JobListDownloadButtonProps {
  jobId: string;
  fileName: string;
}

/** Downloads one of a job's files: fetches a short-lived S3 link from the API, then lets the browser download it. */
export const JobListDownloadButton = (props: JobListDownloadButtonProps) => {
  const { jobId, fileName } = props;
  const [fetchLink, linkState] = getBackgroundJobFileDownload.useLazyQuery();
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    setError(null);
    try {
      const download = await fetchLink({ jobId, fileName }).unwrap();
      window.location.assign(download.url);
    }
    catch (e) {
      setError(toErrorText(e));
    }
  };

  let icon = <DownloadIcon fontSize="small" />;
  if (linkState.isFetching) {
    icon = (
      <CircularProgress
        color="inherit"
        size={14}
        thickness={6}
      />
    );
  }

  return (
    <Tooltip title={error ? `Couldn't download: ${error}` : ""}>
      <Button
        color={error ? "error" : "primary"}
        disabled={linkState.isFetching}
        onClick={() => void handleDownload()}
        size="small"
        startIcon={icon}
        variant="outlined"
      >
        {fileName}
      </Button>
    </Tooltip>
  );
};
